import { getUA, isMobile } from 'react-device-detect';
import { STORAGE_KEYS } from '../constants/storage';
import { storeLocalValue, restoreLocalValue, storeSessionValue, restoreSessionValue } from '../helpers/storage';

const buildClickURLObject = (query = {}) => {
  const { gclid, source, keyword, adAccount } = query;
  const url = window.location.href;
  const page = url.split('?')[0].replace(/\/?$/, '') || '/';
  return {
    url,
    page,
    ...(gclid && { clid: gclid.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('') }),
    ...(source && { source: source.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('') }),
    ...(keyword && { keyword: keyword.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('') }),
    ...(adAccount && { adAccount: adAccount.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join('') }),
  };
};

export const initVisitTracking = (location) => {
  if (typeof window === 'undefined') return;
  const { gclid, source, keyword, adAccount } = location.query || {};
  const hasTrackingParams = gclid || source || keyword || adAccount;
  if (hasTrackingParams) {
    storeSessionValue(STORAGE_KEYS.saleURL, buildClickURLObject(location.query));
  }
  if (restoreLocalValue(STORAGE_KEYS.firstClickURL)) return;
  storeLocalValue(STORAGE_KEYS.firstClickURL, buildClickURLObject(location.query));
};

export const createClickBody = (location) => {
  const { query = {}, pathname = '' } = location;
  const { gclid, source, keyword, adAccount } = query;

  if (gclid) storeLocalValue('gclid', gclid.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join(''));
  if (source) storeLocalValue('source', source.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join(''));
  if (keyword) storeLocalValue('keyword', keyword.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join(''));
  if (adAccount) storeLocalValue('adAccount', adAccount.match(/[a-zA-Z0-9 -_&.\\/]+/gi).join(''));

  const click = {};
  click.requestUri = window.location.href;
  click.userAgent = getUA;

  if (gclid || source || keyword || adAccount) {
    storeLocalValue('requestUri', window.location.href);
  }
  const savedRequestUri = restoreLocalValue('requestUri');
  if (savedRequestUri?.includes(window.location.href)) {
    click.requestUri = savedRequestUri;
  }

  click.device = isMobile && !getUA.includes('Intel') ? 'MOBILE' : 'DESKTOP';

  const fingerprint = restoreLocalValue(STORAGE_KEYS.fingerprint);
  if (fingerprint) click.fingerprint = fingerprint;

  let pageType = 'presellPage';
  if (pathname.includes('EIN')) pageType = 'leadPage';
  else if (pathname.toLowerCase().includes('payment')) pageType = 'checkoutPage';
  else if (pathname.toLowerCase().includes('thankyou')) pageType = 'thankyouPage';
  else if (pathname.toLowerCase().includes('llcupsell')) pageType = 'upsellPage1';
  else if (pathname.endsWith('LLCInc')) pageType = 'upsellPage1';
  click.pageType = pageType;

  if (localStorage?.getItem('crmSessionId') && pageType !== 'presellPage') {
    click.crmSessionId = localStorage.getItem('crmSessionId');
    if (localStorage?.getItem('crmSessionIdLast')) {
      localStorage.removeItem('crmSessionIdLast');
    }
  } else if (localStorage?.getItem('crmSessionIdLast') && pageType === 'thankyouPage') {
    click.crmSessionId = localStorage.getItem('crmSessionIdLast');
  }

  return click;
};

export const appendTrackingToOrder = (order) => {
  const firstClickURL = restoreLocalValue(STORAGE_KEYS.firstClickURL);
  const saleURL = restoreSessionValue(STORAGE_KEYS.saleURL) || firstClickURL || null;
  if (saleURL) {
    order.order ? (order.order.saleURL = saleURL) : (order.order = { saleURL });
  }
  if (firstClickURL) {
    order.order ? (order.order.firstClickURL = firstClickURL) : (order.order = { firstClickURL });
  }
  const fingerprint = restoreLocalValue(STORAGE_KEYS.fingerprint);
  if (fingerprint) {
    order.order ? (order.order.fingerprint = fingerprint) : (order.order = { fingerprint });
  }
};
